module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-1-0f9d4edbefa08353365ab46e58512efb.svg";